import { Currency, CurrencyAmount, Price } from '@kodiak-finance/sdk-core'
import { Position } from '@kodiak-finance/v3-sdk'
import { AutoColumn } from 'components/Column'
import { PositionPreview } from 'components/PositionPreview'
import styled from 'styled-components'

import { Bound, Field } from '../../state/mint/v3/actions'

const Wrapper = styled.div`
  padding-top: 12px;
`

export function Review({
  position,
  outOfRange,
  ticksAtLimit,
  baseCurrencyDefault,
  unwrapNative,
}: {
  position?: Position
  existingPosition?: Position
  parsedAmounts: { [field in Field]?: CurrencyAmount<Currency> }
  priceLower?: Price<Currency, Currency>
  priceUpper?: Price<Currency, Currency>
  outOfRange: boolean
  ticksAtLimit: { [bound in Bound]?: boolean | undefined }
  baseCurrencyDefault?: Currency
  unwrapNative?: boolean
}) {
  return (
    <Wrapper>
      <AutoColumn gap="lg">
        {position ? (
          <PositionPreview
            position={position}
            inRange={!outOfRange}
            ticksAtLimit={ticksAtLimit}
            title="Selected Range"
            baseCurrencyDefault={baseCurrencyDefault}
            unwrapNative={unwrapNative}
          />
        ) : null}
      </AutoColumn>
    </Wrapper>
  )
}
